import { takeLatest } from 'redux-saga/effects';

import commonActionTypes from './action-types';

function* setTestCommonSaga() {
  try {
    yield console.log('setTestCommonSaga');
  } catch (error) {
    console.log(error);
  }
}

function* commonSaga() {
  yield takeLatest(commonActionTypes.SET_TEST_COMMON, setTestCommonSaga);
}

export default commonSaga;
